import React from 'react';
import Button from 'ui/Button';
import useScreens, {
    GROUP_EDIT_SLUG,
} from 'features/SpilKlub/screens/useScreens';
import GroupAvatar from 'features/SpilKlub/components/GroupAvatar';
import icon from 'images/icons/big9/crown-with-border.svg';

const PoolListHeader = ({ group, isGroupOwner = false }) => {
    const { setScreen } = useScreens();
    return (
        <div className={'sk-pools-info flex align-center'}>
            <div className="pools-list-avatar-wrapper">
                <GroupAvatar
                    groupName={group.name}
                    avatarUrl={group?.avatarUrl}
                />
                {group?.expertGroup && (
                    <img className="group-icon" src={icon} alt="icon-top" />
                )}
            </div>
            <div>
                <h4 className={'sk-pools-title no-margin'}>
                    {group.name || ''}
                </h4>
                {group.description ? (
                    <span className={'hyphens'}>{group.description}</span>
                ) : (
                    <>
                        <p className={'sk-pools-description no-margin'}>
                            Gennem SpilKlub25 får du chancen for at være med i
                            større kuponer og dermed øgede muligheder for
                            gevinster.
                        </p>
                        <br />
                        <p className={'sk-pools-description no-margin'}>
                            Velkommen til!
                        </p>
                    </>
                )}
                {isGroupOwner && (
                    <Button
                        lightBlue
                        width={'100%'}
                        margin={'15px 0'}
                        onClick={() =>
                            setScreen(GROUP_EDIT_SLUG, group.poolTemplateId)
                        }
                    >
                        Rediger
                    </Button>
                )}
            </div>
        </div>
    );
};

export default PoolListHeader;
